export class FormDto {
    id: number;
    name: string;
    description: string;
    countFormule: number = 0;    
}
